import type { SummarySort } from '~entities/summary';

import type { SortingState } from '~shared/ui/dashboard-table';

import { ColumnId } from './columns';

const orderMapping = {
  asc: 'ASC',
  desc: 'DESC',
} as const;

type ColumnsWithSort = 'loansAmount' | 'loansCount' | 'salesAmount';

const columnToOrderByMapping: Record<ColumnsWithSort, SummarySort['key']> = {
  [ColumnId.LOANS_AMOUNT]: 'loansAmount',
  [ColumnId.LOANS_COUNT]: 'loansCount',
  [ColumnId.SALES_AMOUNT]: 'salesAmount',
} as const;

export function sortToParams({
  orderBy,
  direction,
}: SortingState): SummarySort {
  return {
    key: columnToOrderByMapping[orderBy as ColumnsWithSort],
    order: orderMapping[direction],
  };
}
